import { getDefaultStdFee, DEFAULT_GAS_LIMIT, DEFAULT_GAS_PRICE, } from './constants.js';
import { toBigNumber, toChainFormat, toHumanReadable, default as BigNumber, } from './classes/BigNumber.js';
export const sleep = (timeout) => new Promise((resolve) => setTimeout(resolve, timeout));
/**
 * When we want to execute the promises in batch
 */
export const awaitAll = async (array, callback) => await Promise.all(array.map(async (item) => await callback(item)));
/**
 * When we want to execute the promises one by one
 * and not all in batch as with await Promise.all()
 */
export const awaitForAll = async (array, callback) => {
    const result = [];
    for (let i = 0; i < array.length; i += 1) {
        try {
            result.push(await callback(array[i]));
        }
        catch {
            //
        }
    }
    return result;
};
export const splitArrayToChunksThrow = ({ array, filter, chunkSize, }) => {
    const chunks = [];
    const chunkSizeInNumber = Number(chunkSize);
    if (isNaN(chunkSizeInNumber)) {
        throw new Error('Invalid chunk size, must be a valid number');
    }
    for (let i = 0; i < array.length; i += chunkSizeInNumber) {
        const chunk = array.slice(i, i + chunkSizeInNumber);
        if (filter) {
            chunks.push(chunk.filter(filter));
        }
        else {
            chunks.push(chunk);
        }
    }
    return chunks;
};
export const splitArrayToChunks = ({ array, filter, chunkSize, }) => {
    try {
        return splitArrayToChunksThrow({ array, chunkSize, filter });
    }
    catch {
        return [array];
    }
};
export const getStdFeeForToken = (token = { denom: 'inj', decimals: 18 }, gasPrice, gasLimit) => {
    const gasPriceInBase = gasPrice || toHumanReadable(DEFAULT_GAS_PRICE, 18);
    const gasPriceScaled = toChainFormat(gasPriceInBase, token.decimals).toFixed(0);
    const gasNormalized = new BigNumber(gasLimit || DEFAULT_GAS_LIMIT).toFixed(0);
    return {
        amount: [
            {
                denom: token.denom,
                amount: new BigNumber(gasPriceScaled).times(gasNormalized).toFixed(),
            },
        ],
        gas: (gasLimit || DEFAULT_GAS_LIMIT).toString(),
    };
};
export const getStdFeeFromObject = (args) => {
    if (!args) {
        return getDefaultStdFee();
    }
    const { payer, granter, feePayer, gasPrice = DEFAULT_GAS_PRICE, gas = DEFAULT_GAS_LIMIT.toString(), } = args;
    const gasNormalized = toBigNumber(gas).toFixed(0);
    const gasPriceNormalized = toBigNumber(gasPrice).toFixed(0);
    return {
        amount: [
            {
                denom: 'inj',
                amount: toBigNumber(gasNormalized).times(gasPriceNormalized).toFixed(),
            },
        ],
        gas: toBigNumber(gasNormalized).toFixed(),
        payer /** for Web3Gateway fee delegation */,
        granter,
        feePayer,
    };
};
export const getStdFeeFromString = (gasPrice) => {
    const matchResult = gasPrice.match(/^([0-9.]+)([a-zA-Z][a-zA-Z0-9/:._-]*)$/);
    if (!matchResult) {
        throw new Error('Invalid gas price string');
    }
    const [_, amount] = matchResult;
    const gas = toChainFormat(amount, 18).dividedBy(DEFAULT_GAS_PRICE).toFixed(0);
    return getStdFeeFromObject({ gas, gasPrice: DEFAULT_GAS_PRICE });
};
export const getStdFee = (args) => {
    if (!args) {
        return getDefaultStdFee();
    }
    if (typeof args === 'string') {
        return getStdFeeFromString(args);
    }
    return getStdFeeFromObject({ ...args });
};
